import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { ThemeConfig } from './theme/index.jsx';
import { router } from './routes';
import { ModalsProvider } from '../hooks/useModals.jsx';
import { UserProvider } from '../hooks/useUser';

const App = () => {
  return (
    <UserProvider>
      <ModalsProvider>
        <ThemeConfig>
          <RouterProvider router={router} />
        </ThemeConfig>
      </ModalsProvider>
    </UserProvider>
  );
};

export default App;

